export default __webpack_public_path__ + "static/media/forward.6404d2e2.webp";